// Break types
export const BREAK_TYPES = {
  REST: 'REST_BREAK',
  MEAL: 'MEAL_BREAK',
};

// Waiver forbidden reasons that match the backend enum
export const WAIVER_FORBIDDEN_REASONS = {
  SHIFT_TOO_LONG: 'SHIFT_TOO_LONG',
  FIRST_BREAK_WAS_WAIVED: 'FIRST_BREAK_WAS_WAIVED',
  SECOND_BREAK_WAS_WAIVED: 'SECOND_BREAK_WAS_WAIVED',
  CANNOT_WAIVE_REST_BREAK: 'CANNOT_WAIVE_REST_BREAK',
};

// Break step constants for the modal
export const BREAK_STEPS = {
  OPTIONS: 'options',
  WAIVER_BREAK_SELECTION: 'waiver_break_selection',
  WAIVER_CONFIRMATION: 'waiver_confirmation',
  START_BREAK_CONFIRMATION: 'start_break_confirmation',
};

// Break action constants
export const BREAK_ACTIONS = {
  START_REST: 'rest',
  START_MEAL: 'meal',
  END_REST: 'endrest',
  END_MEAL: 'endmeal',
  WAIVE: 'waive',
};
